<template>
    <v-dialog v-model="open" max-width="700px" @click:outside="close">
        <v-card>
            <v-card-title>
                <span class="headline">{{ title }}</span>
            </v-card-title>

            <v-card-text>
                <v-container>
                    <v-form ref="editForm">
                        <v-row>
                            <v-col cols="12" sm="6" md="12">
                                <v-textarea v-model="value.description" :rules="[() => {return value.description === '' ? 'Beschreibung darf nicht leer sein' : true}]" label="Beschreibung" rows="1" auto-grow required></v-textarea>
                            </v-col>
                            <v-col cols="12" sm="4" md="4">
                                <v-menu
                                        v-model="menuStart"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="290px"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                                :value="new Date(value.startDate).toLocaleDateString('ch-DE')"
                                                label="Startdatum"
                                                prepend-icon="event"
                                                readonly
                                                v-on="on"
                                        ></v-text-field>
                                    </template>

                                    <v-date-picker v-model="value.startDate" @input="menuStart = false" locale="de-ch"></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="12" sm="4" md="4">
                                <v-menu
                                        v-model="menuEnd"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="290px"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                                :value="new Date(value.endDate).toLocaleDateString('ch-DE')"
                                                label="Enddatum"
                                                :rules="getRules()"
                                                prepend-icon="event"
                                                readonly
                                                v-on="on"
                                        ></v-text-field>
                                    </template>

                                    <v-date-picker v-model="value.endDate" @input="menuEnd = false" locale="de-ch"></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="12" sm="4" md="4">
                                <v-switch v-model="value.confirmed" label="Visiert"></v-switch>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <v-text-field v-model.number="value.shortActivityCount" label="Tätigkeit Kurz Kat-I"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <v-text-field v-model.number="value.shortActivityVolunteerCount" label="Anzahl Freiwillige (Kat-I)"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <v-text-field v-model.number="value.halfDayActivityCount" label="Tätigkeit Halbtag Kat-II"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <v-text-field v-model.number="value.halfDayActivityVolunteerCount" label="Anzahl Freiwillige (Kat-II)"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <v-text-field v-model.number="value.fullDayActivityCount" label="Tätigkeit Ganztag Kat-III"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <v-text-field v-model.number="value.fullDayActivityVolunteerCount" label="Anzahl Freiwillige (Kat-III)"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="12">
                                <v-autocomplete :items="serviceTypes" :rules="[() => {return value.serviceTypeId === 0 ? 'Leistungstyp darf nicht leer sein' : true}]" :loading="serviceTypesLoading" :value="value.serviceTypeId" v-model="value.serviceTypeId" cache-items placeholder="Leistungstyp auswählen"></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6" md="12">
                                <v-autocomplete :items="accounts" :rules="[() => {return value.accountId === 0 ? 'Leistungserbringer darf nicht leer sein' : true}]" :loading="accountsLoading" :value="value.accountId" v-model="value.accountId" cache-items placeholder="Leistungserbringer auswählen"></v-autocomplete>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">Abbrechen</v-btn>
                <v-btn color="success darken-1" text @click="save">Speichern</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import {accountService} from "../services/accountService";
    import {serviceService} from "../services/serviceService";

    export default {
        name: "ServiceModal",
        props: ["value", "open", "title"],
        data: () => {
            return {
                menuStart: false,
                menuEnd: false,
                serviceTypesLoading: true,
                serviceTypes: [],
                accountsLoading: true,
                accounts: [],
            };
        },
        methods: {
            getRules() {
                return [
                    () => {
                        if(this.value.startDate <= this.value.endDate){
                            return true;
                        } else {
                            return "Das Enddatum kann nicht vor dem Startdatum sein"
                        }
                    },
                ];
            },
            save() {
                if(!this.$refs.editForm.validate())
                    return
                this.$emit("input", this.value)
                this.$emit('save');
            },
            close() {
                this.$emit('close');
            },
        },
        created() {
            this.account = this.value;
            let self = this;
            serviceService.getServiceTypes().then((serviceTypes) => {
                for (let i = 0; i < serviceTypes.length; i++) {
                    self.serviceTypes.push({
                        text: serviceTypes[i].name,
                        value: serviceTypes[i].id
                    });
                }
                self.serviceTypesLoading = false;
            }).catch((error) => {
                console.log(error);
            });

            accountService.getQuery("").then(value => {
                for(let i = 0; i < value.length; i++) {
                    self.accounts.push({
                        text: value[i].firstname + " " + value[i].lastname,
                        value: value[i].id,
                    });
                }
                self.accountsLoading = false;
            })
        }
    }
</script>

<style scoped>

</style>